import { queryStudentPaperSend } from '@/api'
import { ImagePreview } from 'vant'

export default {
  name: 'projectDetails-page',
  data () {
    return {
      queryData: null,
      courseInfo: null, // 课程信息
      listimg: [],
      listimg1: []
    }
  },
  created () {
    this.getStudentEvaluationNote()
  },
  destroyed () { },
  methods: {
    Leavingmessage () {
      this.$router.push({ path: '/leavingMessage' })
    },
    async getStudentEvaluationNote () {
      let sellOrderId = null
      let classId = null
      let weekStr = null
      // if (this.$route.query.sellOrderId) {
      //   sellOrderId = this.$route.query.sellOrderId
      //   classId = this.$route.query.classId
      //   weekStr = this.$route.query.weekStr
      // } else {
      //   sellOrderId = this.getQueryString('sellOrderId')
      //   classId = this.getQueryString('classId')
      //   weekStr = this.getQueryString('weekStr')
      // }
      sellOrderId = this.getQueryString('sellOrderId')
      classId = this.getQueryString('classId')
      weekStr = this.getQueryString('weekStr')
      const { data } = await queryStudentPaperSend({ sellOrderId: sellOrderId, classId: classId, weekStr: weekStr })
      this.queryData = data
      this.courseInfo = data.courseInfo
      this.listimg = this.queryData.sendResult.image.map(item => { return item.url })
      this.listimg1 = this.queryData.registerImage.map(item => { return item.url })
      this.queryData.sendResult.image = this.groupList(this.queryData.sendResult.image)
      this.queryData.registerImage = this.groupList(this.queryData.registerImage)
    },
    groupList (list) {
      const arr = []
      for (var i = 0; i < list.length; i += 2) {
        arr.push(list.slice(i, i + 2))
      }
      return arr
    },
    getQueryString (name) {
      const url1 = window.location.search
      const url = decodeURI(url1)
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const r = url.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      };
      return null
    },
    // 查看图片
    show_before_img (item) {
      ImagePreview({
        images: item,
        showIndex: false,
        closeOnPopstate: true,
        closeable: true
      })
    }
  }
}
